import en from './messages/en';

export default {
  en,
};



// WEBPACK FOOTER //
// ./src/i18n/messages.js